import styled from 'styled-components';

import { COLORS } from '~/src/common/theme';
import { media } from '~/src/common/theme/deprecated';

export const ApplesContainer = styled.div`
  display: flex;
  gap: 16px;
  position: relative;
  text-align: center;

  /* ligne de séparation */
  &::before {
    content: '';
    position: absolute;
    top: 60%;
    left: 8px;
    height: 1px;
    background: ${COLORS.NEUTRAL_STROKE};
    width: calc(100% - 16px);
    transform: translateY(-50%);
  }

  svg {
    z-index: 1; /* contenu au dessus de la ligne */
  }
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  background-color: ${COLORS.NEUTRAL_WHITE};
  padding: 24px 16px;
  min-width: 250px;
  max-width: 250px;
  align-items: center;
  gap: 16px;
  z-index: 1; /* contenu au dessus de la ligne */

  & p {
    margin: 0;
  }

  & > p:first-of-type {
    align-self: center;
    text-align: center;
    color: ${COLORS.ACTION_DEFAULT};
    font-weight: 500;
    font-size: 16px;
    background-color: ${COLORS.NEUTRAL_WHITE};
    border-radius: 4px;
    padding: 8px;
  }

  & > p:nth-of-type(2) {
    text-align: center;
    color: ${COLORS.ACTION_DEFAULT};
    font-weight: 700;
    font-size: 28px;
  }

  & > p:last-of-type {
    text-align: center;
    font-weight: 400;
    font-size: 14px;
  }

  ${media.M`
    width: 308px;
  `}
`;
